<template>
  <div class="tabs-demo">
    <div class="export-btn">
      <el-button @click="exportScreen" v-if="filtering('modulesClients:exportFilter')">导出筛选</el-button>
      <el-button @click="exportChecked" v-if="filtering('modulesClients:exportSelected')" :disabled="!selected.length"
        >导出选中</el-button
      >
    </div>
    <vs-table :multiple="true" v-model="selected" :data="list" noDataText="暂无数据">
      <template slot="thead">
        <vs-th sort-key="">序号</vs-th>
        <vs-th sort-key="">编码</vs-th>
        <vs-th sort-key="">名称</vs-th>
        <vs-th sort-key="">联系方式</vs-th>
        <vs-th sort-key="">上级</vs-th>
        <vs-th sort-key="">类别</vs-th>
        <vs-th sort-key="">类型</vs-th>
        <vs-th sort-key="">价格模板</vs-th>
        <vs-th>操作</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ indextr + 1 }}
              </p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.outCode }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.phone }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.parentName }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.category }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.type }}</p>
            </vs-td>

            <vs-td>
              <p class="">{{ tr.priceTemplate }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <!--                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
              <a href="javascript:;" @click="editStaff(tr)" v-if="filtering('modulesClients:detail')">查看</a>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <gc-vs-pagination
      v-if="pageShow"
      :pager="pagination"
      totalName="totalCount"
      pageNoName="pagerNo"
      pageSizeName="pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></gc-vs-pagination>
  </div>
</template>

<script>
import moment from "moment";
import { downloadExcel, downloadFileTemplate } from "@/utils/downloadExcel.js";
import { Mod_Account } from "@/modules/server-api/Accounts";
import { Mod_Clients } from "../../server-api/Clients";
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import { Model_Boss_Staff } from "../../../group-cloud/model/boss/Staff";
import { Navigator } from "@/router/Navigator";
  import VsTable from "@/modules/order/vsTable/vsTable"

export default {
  name: "clients-list-table",
  components: {
    GcCmpVsTable,
    VsTable,
  },
  props: {},
  data() {
    return {
      selectTJ: {}, //筛选条件
      selected: [],
      seq: 0,
      keyword: "",
      pageShow: true,
      pagination: {
        // 分页
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
      },
      list: [],
    };
  },
  computed: {
    products() {
      return this.list;
    },
  },
   watch:{

      // selected(array) {
      //   console.log(array)

      // },


    },
  methods: {
    //导出筛选
    async exportScreen() {
      console.log(this.selected, this.selectTJ);
      let params = {
        ...this.selectTJ,
      };
      let url = "/data-dist/api/dist/yoozClient/clinetExportExecl";
      let fileName = "客户管理列表.xlsx";
      downloadExcel(url, params, fileName);
    },
    //导出选中
    async exportChecked() {
      this.selected.forEach(item=>{
        Object.keys(item).forEach(v=>{
          console.log(item[v]);
          if(item[v]){
            if(item[v] === null || item[v] === 'null'|| item[v] === 'nullnull'){
              item[v] = ''
            }
          }

        })
      })
      let params = {
        yoozClientList: this.selected,
      };
      let url = "/data-dist/api/dist/yoozClient/clinetExportExecl";
      let fileName = "客户管理列表.xlsx";
      downloadExcel(url, params, fileName);
      // let resp = await Mod_Clients.exportData(params);
    },
    // async exportData(id) {
    // let url = '/data-dist/api/dist/activityConfig/getAlonePushExcel?type=1&configId='+id;
    // let name = '列表导出.xlsx';
    // downloadFileTemplate(url, name);
    // },
    transRoles(record) {
      return Mod_Account.getRecordRoleString(record);
    },
    getSelect(selectTJ) {
      this.selectTJ = selectTJ;
      this.pagination.pageNo = 1;
      this.pagination.pageSize = 20;
      this.getList();
      this.pageShow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageShow = true;
      });

      this.getList();
    },
    getEmptySearch() {
      this.selectTJ = {};
      this.pagination.pageNo = 1;
      this.pagination.pageSize = 20;
      this.getList();
      this.pageShow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageShow = true;
      });
    },
    async getList() {
      let params = {
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        data: {
          ...this.selectTJ,
        },
      };

      let resp = await Mod_Clients.getClientList(params);
      this.seq = 0;
      console.log(resp);
      if (resp && resp.list) {
        this.list = resp.list;
        console.log(this.list, "数据");
        this.pagination.totalCount = resp.totalCount;
      }
      return resp;
    },

    // ============================ 列表相关
    //更改每页条数
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getList();
    },
    editStaff(row) {
      // let path = `/modules/clients/view/${uid}`;
      // Navigator.redirect(path);

      this.$router.push({
        path: "/modules/clients/view/",
        query: {
          rowData: row,
        },
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
</style>
